import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { MessageContext } from "../../../../common/message";
import { POST } from "../../../../utils/fetchUtil";
import { cleanJoin } from "../../../../utils/stringUtil";
import { RequestSubmissionContext } from "../RequestSubmissionContext";

function Submit({ display, disabled, label, id, uid }) {
  const { state, dispatch } = useContext(RequestSubmissionContext);
  const message = useContext(MessageContext);
  const { t } = useTranslation();
  const history = useHistory();

  // TODO Construct what exactly to send from state¸
  const submit = () => {
    dispatch({ type: "unblock" });
    message.toggle({
      title: t("requests.submission.actions.submitRequest.title"),
      content: t("requests.submission.actions.submitRequest.content"),
      onNo: () => message.toggle({}),
      onYes: () => {
        message.toggle({});
        message.toggle({
          title: "",
          content: t("requests.overview.submitted.wait.label"),
          hideNo: true,
          hideYes: true,
          hideX: false,
          isWait: true,
        });
        POST(
          `${process.env.REACT_APP_GATEWAY_URL}/requests/${id}/submissions/${uid}`,
          state,
          () => {
            message.toggle({});

            dispatch({ type: "unblock" });
            message.toggle({
              title: t("requests.submission.actions.submitRequest.title"),
              content: t("requests.submission.actions.submitRequest.info"),
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
                history.push("/requests", "/requests/#t1");
              },
            });
          },

          (err) => {
            message.toggle({});
            message.toggle({
              title: "Greška",
              content: "Došlo je do greške: " + err,
              hideNo: true,
              yesLabel: "Ok",
              onYes: () => {
                message.toggle({});
              },
            });
          }
        );
      },
    });
  };

  return display ? (
    <button
      disabled={disabled}
      className={cleanJoin(
        "button",
        "pdf-form-action-button",
        "no-focus-outline",
        "has-border-green-1",
        !disabled
          ? "has-background-green-on-hover has-text-white-on-hover has-opacity-71-on-hover"
          : ""
      )}
      onClick={submit}
    >
      {label}
    </button>
  ) : null;
}

export default Submit;
